import type { ReactNode } from 'react';
import { motion } from 'motion/react';
import { TextMorph } from 'torph/react';
import { ADMIN_COLORS, staggerItem } from '@/features/admin/utils/adminAnimations';

interface PageHeaderProps {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export function PageHeader({ icon, title, subtitle, action }: PageHeaderProps) {
  return (
    <motion.div variants={staggerItem} className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div
          className="w-14 h-14 rounded-xl flex items-center justify-center glass-surface"
          style={{
            backgroundColor: ADMIN_COLORS.surface,
            border: `1px solid ${ADMIN_COLORS.border}`,
            boxShadow: ADMIN_COLORS.shadow,
          }}
        >
          {icon}
        </div>
        <div>
          <h1 className="text-lg sm:text-2xl font-semibold tracking-wide">
            <TextMorph as="span" duration={300} locale="he" respectReducedMotion>
              {title}
            </TextMorph>
          </h1>
          {subtitle && (
            <p className="text-xs sm:text-sm text-slate-500">{subtitle}</p>
          )}
        </div>
      </div>
      {action && <div className="flex items-center gap-2">{action}</div>}
    </motion.div>
  );
}
